export const ActionTypes = {
  IS_MOBILE_DEVICE: "IS_MOBILE_DEVICE",
  TOGGLE_DRAWER: "TOGGLE_DRAWER",
  SOCKET_CONNECTION: "SOCKET_CONNECTION",
  RENAME_VIDEO_FROM_PLAYLIST: "RENAME_VIDEO_FROM_PLAYLIST",
  REMOVE_VIDEO_FROM_PLAYLIST: "REMOVE_VIDEO_FROM_PLAYLIST",
  SET_PLAYLIST_DATA: "SET_PLAYLIST_DATA",
  UPDATE_PLAYLIST_MEDIA: "UPDATE_PLAYLIST_MEDIA",
  SET_DISABLE_SCREEN: "SET_DISABLE_SCREEN",
  SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
  SET_BREAKDOWN_REQUESTS_DATA: "SET_BREAKDOWN_REQUESTS_DATA",
  UPDATE_BREAKDOWN_PAGE: "UPDATE_BREAKDOWN_PAGE",
  UPDATE_BREAKDOWN_CONTENT: "UPDATE_BREAKDOWN_CONTENT",
  SET_USER_INFORMATION: "SET_USER_INFORMATION",
  SET_LOGGED_IN_USER_IMAGE: "SET_LOGGED_IN_USER_IMAGE",
  SET_SCHOOL_NAME: "SET_SCHOOL_NAME",
  SET_CURRENT_SEASON: "SET_CURRENT_SEASON",
  SET_WEEK_LIST: "SET_WEEK_LIST",
  SET_OPPONENT_SCHOOL_LIST: "SET_OPPONENT_SCHOOL_LIST",
  SET_FORM_HOOK: "SET_FORM_HOOK",
  TOGGLE_BUILD_SCHEDULE_POPUP: "TOGGLE_BUILD_SCHEDULE_POPUP",
  SET_CURRENT_SEASON: "SET_CURRENT_SEASON",
  SET_EDIT_SCHEDULE: "SET_EDIT_SCHEDULE",
  SET_SCHEDULE_INFORMATION: "SET_SCHEDULE_INFORMATION",
  SET_CURRENT_SEASON_IN_USER_PROFILE: "SET_CURRENT_SEASON_IN_USER_PROFILE",
  EDIT_BREAKDOWN: "EDIT_BREAKDOWN",
  OPEN_OR_CLOSE_BREAKDOWNPOPUP: "OPEN_OR_CLOSE_BREAKDOWNPOPUP",
  OPEN_EDIT_BREAKDOWN_POPUP: "OPEN_EDIT_BREAKDOWN_POPUP",
  CLOSE_EDIT_BREAKDOWN_POPUP: "CLOSE_EDIT_BREAKDOWN_POPUP",
  OPEN_SUCCESS_POPUP: "OPEN_SUCCESS_POPUP",
  CLOSE_SUCCESS_POPUP: "CLOSE_SUCCESS_POPUP",
  OPEN_RENAME_POPUP: "OPEN_RENAME_POPUP",
  CLOSE_RENAME_POPUP: "CLOSE_RENAME_POPUP",
  OPEN_CONFIRMATION_POPUP: "OPEN_CONFIRMATION_POPUP",
  CLOSE_CONFIRMATION_POPUP: "CLOSE_CONFIRMATION_POPUP",
  OPEN_VIDEO_POPUP: "OPEN_VIDEO_POPUP",
  CLOSE_VIDEO_POPUP: "CLOSE_VIDEO_POPUP",
  RENAME_VIDEO_LOADING: "RENAME_VIDEO_LOADING",
  RENAME_VIDEO: "RENAME_VIDEO",
  DELETE_OR_RENAME_VIDEO: "DELETE_OR_RENAME_VIDEO",
  RENAME_VIDEO_INFORMATION: "RENAME_VIDEO_INFORMATIONI",
  SEND_HIGHLIGHT_REQUEST: "SEND_HIGHLIGHT_REQUEST",
  SET_INSEASON_DATA: "SET_INSEASON_DATA",
  SET_OFFSEASON_DATA: "SET_OFFSEASON_DATA",
  SET_OTHERSEASON_DATA: "SET_OTHERSEASON_DATA",
  SET_ALL_SEASON_DATA: "SET_ALL_SEASON_DATA",
  FETCH_ALL_SEASON_DATA: "FETCH_ALL_SEASON_DATA",
  CHECK_UNCHECK_VIDEO: "CHECK_UNCHECK_VIDEO",
  SET_SELECTED_SEASON: "SET_SELECTED_SEASON",
  SET_SELECTED_EVENT: "SET_SELECTED_EVENT",
  SET_VIDEO_LIST: "SET_VIDEO_LIST",
  SET_SELECTED_OFFSEASON_EVENT: "SET_SELECTED_OFFSEASON_EVENT",
  DELETE_VIDEO_FROM_PAST_SEASON: "DELETE_VIDEO_FROM_PAST_SEASON",
  UPDATE_NUMBER_OF_VIDEOS_IN_WEEKLIST: "UPDATE_NUMBER_OF_VIDEOS_IN_WEEKLIST",
  SET_DELETED_VIDEOS: "SET_DELETED_VIDEOS",
  DELETE_VIDEO_FROM_STORAGE_MANAGEMENT: "DELETE_VIDEO_FROM_STORAGE_MANAGEMENT",
  SELECT_UNSELECT_VIDEO_ON_STORAGE_MANAGEMENT:
    "SELECT_UNSELECT_VIDEO_ON_STORAGE_MANAGEMENT",
  UNSELECT_ALL_VIDEO_ON_STORAGE_MANAGEMENT:
    "UNSELECT_ALL_VIDEO_ON_STORAGE_MANAGEMENT",
  RESTORE_DELETED_VIDEOS: "RESTORE_DELETED_VIDEOS",
  SEARCH_VIDEOS: "SEARCH_VIDEOS",
  SET_UNSEARCH_RECORD: "SET_UNSEARCH_RECORD",
  SET_STORAGE_MANAGEMENT_LOADING: "SET_STORAGE_MANAGEMENT_LOADING",
  REMOVE_DELETED_VIDEOS: "REMOVE_DELETED_VIDEOS",
  OPEN_FAIL_DIALOG: "OPEN_FAIL_DIALOG",
  CLOSE_FAIL_DIALOG: "CLOSE_FAIL_DIALOG",
  SET_UPLOADED_VIDEO_LIST: "SET_UPLOADED_VIDEO_LIST",
  REMOVE_UPLOADED_VIDEO: "REMOVE_UPLOADED_VIDEO",
  REMOVE_UPLOADED_VIDEO_BY_INDEX: "REMOVE_UPLOADED_VIDEO_BY_INDEX",
  RENAME_UPLOADED_VIDEO: "RENAME_UPLOADED_VIDEO",
  RENAME_UPLOADED_VIDEO_LOADING: "RENAME_UPLOADED_VIDEO_LOADING",
  GET_VIDEO_EDIT_ACTIVITY: "GET_VIDEO_EDIT_ACTIVITY",
  GET_VIDEO_SHARED_ACTIVITY: "GET_VIDEO_SHARED_ACTIVITY",
  GET_MEMBER_ADDED_ACTIVITY: "GET_MEMBER_ADDED_ACTIVITY",
  GET_SEASON_ADDED_ACTIVITY: "GET_SEASON_ADDED_ACTIVITY",
  GET_SCHEDULE_ADDED_ACTIVITY: "GET_SCHEDULE_ADDED_ACTIVITY",
  GET_ALL_ACTIVITY: "GET_ALL_ACTIVITY",
  ACTIVITY_HISTORY_LOADING: "ACTIVITY_HISTORY_LOADING",
  ACTIVITY_HISTORY_ERROR: "ACTIVITY_HISTORY_ERROR",
  RESET_ACTIVITY_HISTORY_INITIAL_STATE: "RESET_ACTIVITY_HISTORY_INITIAL_STATE",
  RESET_VIDEOLIBRARY_INITIAL_STATE: "RESET_VIDEOLIBRARY_INITIAL_STATE",
  RESET_UPLOAD_VIDEO_INITIAL_STATE: "RESET_UPLOAD_VIDEO_INITIAL_STATE",
  SET_EDIT_FILTER: "SET_EDIT_FILTER",
  TOGGLE_ADD_OR_EDIT_BREAKDOWN: "TOGGLE_ADD_OR_EDIT_BREAKDOWN",
  SET_EDIT_FILTER_INFORMATION: "SET_EDIT_FILTER_INFORMATION",
  SET_EDIT_BREAKDOWN: "SET_EDIT_BREAKDOWN",
  SET_EDIT_BREAKDOWN_INFORMATION: "SET_EDIT_BREAKDOWN_INFORMATION",
  RESET_BREAKDOWN_VALUES: "RESET_BREAKDOWN_VALUES",
  SET_SCHOOL_ADMIN_PROFILE_IMAGE: "SET_SCHOOL_ADMIN_PROFILE_IMAGE",
  RESET_SCHOOL_ADMIN_INFORMATION: "RESET_SCHOOL_ADMIN_INFORMATION",
  SET_INTERCUT_VIDEO_LIST: "SET_INTERCUT_VIDEO_LIST",
  SET_INTERCUT_VIDEO_LIST_AFTER_DRAG_AND_DROP:
    "SET_INTERCUT_VIDEO_LIST_AFTER_DRAG_AND_DROP",
  RENAME_INTERCUT_VIDEO: "RENAME_INTERCUT_VIDEO",
  RENAME_INTERCUT_LOADING: "RENAME_INTERCUT_LOADING",
  DELETE_INTERCUT_VIDEO: "DELETE_INTERCUT_VIDEO",
  SET_VIDEO_PLAY_INFORMATION: "SET_VIDEO_PLAY_INFORMATION",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESTORE_DELETED_SCHOOL: "RESTORE_DELETED_SCHOOL",
  GET_SELECTED_SCHOOL_INFORMATION: "GET_SELECTED_SCHOOL_INFORMATION",
  DELETE_SCHOOL: "DELETE_SCHOOL",
  ACTIVATE_OR_DEACTIVATE_SCHOOL: "ACTIVATE_OR_DEACTIVATE_SCHOOL",
  SUPER_ADMIN_LOADING: "SUPER_ADMIN_LOADING",
  VIDEO_LIBRARY_LOADING: "VIDEO-LIBRARY_LOADING",
  SET_SELECTED_GROUP_DETAILS: "SET_SELECTED_GROUP_DETAILS",
  GROUP_LOADING: "GROUP_LOADING",
  ACTIVATE_OR_DEACTIVATE_GROUP: "ACTIVATE_OR_DEACTIVATE_GROUP",
  DELETE_GROUP: "DELETE_GROUP",
  GET_ALL_GROUP_LIST: "GET_ALL_GROUP_LIST",
  GET_ACTIVE_COACHES_LIST: "GET_ACTIVE_COACHES_LIST",
  GET_ACTIVE_ATHELETS_LIST: "GET_ACTIVE_ATHELETS_LIST",
  SET_SELECTED_COACHES_LIST: "SET_SELECTED_COACHES_LIST",
  SET_SELECTED_ATHLETES_LIST: "SET_SELECTED_ATHLETES_LIST",
  SET_SELECTED_TEAM_ADMINS_LIST: "SET_SELECTED_TEAM_ADMINS_LIST",
  GET_ACTIVE_TEAM_ADMINS_LIST: "GET_ACTIVE_TEAM_ADMINS_LIST",
  HANDLE_GROUP_LOGO_UPLOAD: "HANDLE_GROUP_LOGO_UPLOAD",
  RESET_GROUP_DATA: "RESET_GROUP_DATA",
  SET_GROUP_SEARCH_QUERY: "SET_GROUP_SEARCH_QUERY",
  SET_GROUP_SEARCHED_RECORD: "SET_GROUP_SEARCHED_RECORD",
  SEARCH_ACTIVE_COACHES: "SEARCH_ACTIVE_COACHES",
  SEARCH_ACTIVE_ATHLETES: "SEARCH_ACTIVE_ATHLETES",
  SEARCH_ACTIVE_TEAM_ADMINS: "SEARCH_ACTIVE_TEAM_ADMINS",
  SET_VIDEO_LIBRARY_FILTER_LIST: "SET_VIDEO_LIBRARY_FILTER_LIST",
  DELETE_FILTER: "DELETE_FILTER",
  OPEN_ADD_FILTER_POPUP: "OPEN_ADD_FILTER_POPUP",
  ADD_NEW_FILTER: "ADD_NEW_FILTER",
  UPDATE_FILTER: "UPDATE_FILTER",
  FILTER_LOADING: "FILTER_LOADING",
  GET_TEAM_ADMIN_PERMISSIONS: "GET_TEAM_ADMIN_PERMISSIONS",
  SELECT_UNSELECT_TEAM_ADMIN_PERMISSIONS:
    "SELECT_UNSELECT_TEAM_ADMIN_PERMISSIONS",
  RESET_TEAM_ADMIN_DATA: "RESET_TEAM_ADMIN_DATA",
  ADD_TEAM_ADMIN: "ADD_TEAM_ADMIN",
  GET_ALL_TEAM_ADMIN_SPECIALITY: "GET_ALL_TEAM_ADMIN_SPECIALITY",
  HANDLE_TEAM_ADMIN_LOGO_UPLOAD: "HANDLE_TEAM_ADMIN_LOGO_UPLOAD",
  GET_TEAM_ADMIN_DATA: "GET_TEAM_ADMIN_DATA",
  SET_TEAM_ADMIN_SPECIALITY: "SET_TEAM_ADMIN_SPECIALITY",
  UPDATE_TEAM_ADMIN: "UPDATE_TEAM_ADMIN",
  TEAM_ADMIN_LOADING: "TEAM_ADMIN_LOADING",
  SET_SELECTED_GROUPS_LIST: "SET_SELECTED_GROUPS_LIST",
  SEARCH_GROUP: "SEARCH_GROUP",
  DELETE_TEAM_ADMIN: "DELETE_TEAM_ADMIN",
  ACTIVATE_INACTIVATE_TEAM_ADMIN: "ACTIVATE_INACTIVATE_TEAM_ADMIN",
  GET_COACH_DETAILS: "GET_COACH_DETAILS",
  HANDLE_COACH_LOGO_UPLOAD: "HANDLE_COACH_LOGO_UPLOAD",
  SELECT_UNSELECT_COACH_PERMISSIONS: "SELECT_UNSELECT_COACH_PERMISSIONS",
  GET_COACH_PERMISSIONS: "GET_COACH_PERMISSIONS",
  ACTIVATE_INACTIVATE_COACH: "ACTIVATE_INACTIVATE_COACH",
  DELETE_COACH: "DELETE_COACH",
  COACH_LOADING: "COACH_LOADING",
  GET_COACH_SPECIALITY_LIST: "GET_COACH_SPECIALITY_LIST",
  SET_COACH_SPECIALITY: "SET_COACH_SPECIALITY",
  RESET_COACH_DATA: "RESET_COACH_DATA",
  ADD_COACH: "ADD_COACH",
  EDIT_COACH: "EDIT_COACH",
  FULL_PAGE_LOADING: "FULL_PAGE_LOADING",
  CONTENT_LAYOUT_LOADING: "CONTENT_LAYOUT_LOADING",
  GET_ATHLETE_DATA: "GET_ATHLETE_DATA",
  RESET_ATHLETE_DATA: "RESET_ATHLETE_DATA",
  ATHLETE_LOADING: "ATHLETE_LOADING",
  HANDLE_ATHLETE_LOGO_UPLOAD: "HANDLE_ATHLETE_LOGO_UPLOAD",
  DELETE_ATHLETE: "DELETE_ATHLETE",
  ACTIVATE_INACTIVATE_ATHLETE: "ACTIVATE_INACTIVATE_ATHLETE",
  SET_ATHLETE_GRADUATION_YEAR: "SET_ATHLETE_GRADUATION_YEAR",
  EDIT_ATHLETE: "EDIT_ATHLETE",
  ADD_ATHLETE: "ADD_ATHLETE",
  ADD_FMC_TOKEN: "ADD_FMC_TOKEN",
  VIDEO_STREAM_STATUS: "VIDEO_STREAM_STATUS",
  SET_VIDEO_STREAM_CHANNEL_LIST: "SET_VIDEO_STREAM_CHANNEL_LIST",
  START_STREAMING: "START_STREAMING",
  STOP_STREAMING: "STOP_STREAMING",
  VIDEO_STREAMING_STARTED_POPUP: "VIDEO_STREAMING_STARTED_POPUP",
  SET_LATEST_STARTED_CHANNEL_NAME: "SET_LATEST_STARTED_CHANNEL_NAME",
  ADD_AVS_CHANNEL_DETAILS: "ADD_AVS_CHANNEL_DETAILS",
  SET_ALL_AVS_CHANNEL_LIST: "SET_ALL_AVS_CHANNEL_LIST",
  UPDATE_CHANNEL_STATUS: "UPDATE_CHANNEL_STATUS",
  SET_CURRENT_CHANNEL_INFORMATION: "SET_CURRENT_CHANNEL_INFORMATION",
  FETCH_ALL_LIVE_CHANNELS: "FETCH_ALL_LIVE_CHANNELS",
  UPDATE_LIVE_CHANNELS: "UPDATE_LIVE_CHANNELS",
  SET_EDITED_VIDEO_DATA: "SET_EDITED_VIDEO_DATA",
  SET_RECORDING: "SET_RECORDING",
  SET_CAMERA_ANGLE: "SET_CAMERA_ANGLE",
  /*Video Editing*/
  SET_SELECTED_VIDEO_PATH: "SET_SELECTED_VIDEO_PATH",
  SET_TEXT: "SET_TEXT",
  SET_EDITED_VIDEO_NAME: "SET_EDITED_VIDEO_NAME",
  SET_START_TIME: "SET_START_TIME",
  SET_DURATION: "SET_DURATION",
  SET_VIDEO_PATH_FOR_TRIM: "SET_VIDEO_PATH_FOR_TRIM",
  HANDLE_EDIT_ICON_CLICK: "HANDLE_EDIT_ICON_CLICK",
  SET_SHOW_SLIDER: "SET_SHOW_SLIDER",
  SET_SHOW_TRIMMER: "SET_SHOW_TRIMMER",
  SET_EDIT_ICONS: "SET_EDIT_ICONS",
  SET_DATA_AFTER_VIDEO_EDIT: "SET_DATA_AFTER_VIDEO_EDIT",
  HANDLE_DELETED_VIDEO: "HANDLE_DELETE_VIDEO",
  HANDLE_VIDEO_SELECTION: "HANDLE_VIDEO_SELECTION",
  SET_SELECTED_THEME: "SET_SELECTED_THEME",
  SET_HIGHLIGHT_TITLE: "SET_HIGHLIGHT_TITLE",
  SET_THEME_IMAGE_URL: "SET_THEME_IMAGE_URL",
  SET_SHOW_TOOLKIT: "SET_SHOW_TOOLKIT",
  SET_SHOW_TOOLKIT_SECOND: "SET_SHOW_TOOLKIT_SECOND",
  SET_TOOLKIT_URL: "SET_TOOLKIT_URL",
  SET_THEME_HIGHLIGHT_TITLE_COLOR: "SET_THEME_HIGHLIGHT_TITLE_COLOR",
  ADD_VIDEO_SCHEDULE_INFORMATION: "ADD_VIDEO_SCHEDULE_INFORMATION",
  RESET_VIDEO_SCHEDULE_EVENT_DATA: "RESET_VIDEO_SCHEDULE_EVENT_DATA",
  ADD_PLAYLIST_DATA: "ADD_PLAYLIST_DATA",
  IP_CAMERA_VIDEO_STREAMING_STATUS: "IP_CAMERA_VIDEO_STREAMING_STATUS",
  RESET_VIDEO_STREAMING_INFORMATION: "RESET_VIDEO_STREAMING_INFORMATION",
  UPDATE_ACTIVE_IP_CAMERA_COUNT: "UPDATE_ACTIVE_IP_CAMERA_COUNT",
  IP_CAMERA_REQUEST_POPUP: "IP_CAMERA_REQUEST_POPUP",
  IP_CAMERA_PREVIEW_STATUS: "IP_CAMERA_PREVIEW_STATUS",
  ALLOCATE_IP_CAMERA_ANGLE: "ALLOCATE_IP_CAMERA_ANGLE",
  IP_CAMERA_ANGLE_LIST: "IP_CAMERA_ANGLE_LIST",
  REQUEST_IP_CAMERA_DISCONNECTION: "REQUEST_IP_CAMERA_DISCONNECTION",
  CANCEL_IP_CAMERA_REQUEST: "CANCEL_IP_CAMERA_REQUEST",
  SET_BREAKDOWNTABLE_LIST: "SET_BREAKDOWNTABLE_LIST",
  SET_SEARCHED_BREAKDOWNTABLE_LIST: "SET_SEARCHED_BREAKDOWNTABLE_LIST",
  SET_SEARCHED_BREAKDOWN_STATUS: "SET_SEARCHED_BREAKDOWN_STATUS",
  BREAKDOWN_TABLE_LOADING: "BREAKDOWN_TABLE_LOADING",
  BREAKDOWN_TABLE_FULL_PAGE_LOADING: "BREAKDOWN_TABLE_FULL_PAGE_LOADING",
  UPDATE_BREAKDOWN: "UPDATE_BREAKDOWN",
  ADD_BREAKDOWN: "ADD_BREAKDOWN",
  DELETE_BREAKDOWN: "DELETE_BREAKDOWN",
  BREAKDOWN_BUTTON_LOADING: "BREAKDOWN_BUTTON_LOADING",
  SET_THEME_POPUP: "SET_THEME_POPUP",
  SET_IS_OVERLAY_TEXT: "SET_IS_OVERLAY_TEXT",
  SET_SHOW_SELECTION_TOOLKIT: "SET_SHOW_SELECTION_TOOLKIT",
  SET_THEME_IMAGE_URL_SEND: "SET_THEME_IMAGE_URL_SEND",
  SET_VIDEO_EDIT_DATA: "SET_VIDEO_EDIT_DATA",
  SELECTED_VIDEO_PATH: "SELECTED_VIDEO_PATH",
  SET_EDITED_VIDEO_POSITION: "SET_EDITED_VIDEO_POSITION",
  SET_BACKDROP: "SET_BACKDROP",
  SET_PROGRESS_BAR: "SET_PROGRESS_BAR",
  SET_FINISHED_EDIT: "SET_FINISHED_EDIT",
  OPEN_NAME_DIALOG: "OPEN_NAME_DIALOG",
  OPEN_VIDEO_EDIT_POPUP: "OPEN_VIDEO_EDIT_POPUP",
  VIDEO_EDIT_POPUP_DATA: "VIDEO_EDIT_POPUP_DATA",
  REPLACE_EDITED_INTERCUT_VIDEO: "REPLACE_EDITED_INTERCUT_VIDEO",
  REPLACE_EDITED_INTERCUT_VIDEO_LOADING:
    "REPLACE_EDITED_INTERCUT_VIDEO_LOADING",
  MAXIMIZE_LIBRARY_PAGE: "MAXIMIZE_LIBRARY_PAGE",
  RENAME_RECORDING: "RENAME_RECORDING",
  OPEN_STREAM_CAMERA: "OPEN_STREAM_CAMERA",
  SET_ODK_DATA: "SET_ODK_DATA",
};

export const VideoLibraryDataTableActionTypes = {
  SET_SELECTED_PLAYLIST: "SET_SELECTED_PLAYLIST",
  UPDATE_BREAKDOWN_POSSIBLE_VALUE: "UPDATE_BREAKDOWN_POSSIBLE_VALUE",
  SET_SELECTED_COLUMN_SET: "SET_SELECTED_COLUMN_SET",
  SET_VIDEO_LIBRARY_TABLE_DATA: "SET_VIDEO_LIBRARY_TABLE_DATA",
  SET_IS_TABLE_DISABLED: "SET_IS_TABLE_DISABLED",
  SET_ACTIVE_BREAKDOWN_LIST: "SET_ACTIVE_BREAKDOWN_LIST",
  SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME: "SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME",
  FILTER_TABLE: "FILTER_TABLE",
  APPLIED_FILTER_LIST: "APPLIED_FILTER_LIST",
  SET_FILTER_VALUES: "SET_FILTER_VALUES",
  TABLE_LOADING: "TABLE_LOADING",
  SELECTED_VIDEO_PATH: "SELECTED_VIDEO_PATH",
  RESET_TABLE: "RESET_TABLE",
  SET_ERRORS: "SET_ERRORS",
  UPDATE_BREAKDOWN_VALUE: "UPDATE_BREAKDOWN_VALUE",
  ADD_BREAKDOWN_VALUE: "ADD_BREAKDOWN_VALUE",
  UPDATE_VIDEO_NAME: "UPDATE_VIDEO_NAME",
  DELETE_BREAKDOWN: "DELETE_BREAKDOWN",
  UPDATE_BREAKDOWN: "UPDATE_BREAKDOWN",
  IS_TABLE_EDITABLE: "IS_TABLE_EDITABLE",
  SAVE_TABLE: "SAVE_TABLE",
  LOADING_ON_TABLE_DATA_ADD_EDIT: "LOADING_ON_TABLE_DATA_ADD_EDIT",
  SET_COLUMN_FILTER_VALUE: "SET_COLUMN_FILTER_VALUE",
  SET_SEASON_INFO_OF_TABLE: "SET_SEASON_INFO_OF_TABLE",
  SET_TABLE_DATA: "SET_TABLE_DATA",
  RENAME_RECORDING: "RENAME_RECORDING",
};

export const feedPageActionTypes = {
  END_TOTAL_POST: "END_TOTAL_POST",
  SET_ALL_POST_LIST: "SET_ALL_POST_LIST",
  LIKE_DISLIKE_POST: "LIKE_DISLIKE_POST",
  ADD_COMMENT: "ADD_COMMENT",
  TOGGLE_SHARE_VIDEO_POPUP: "TOGGLE_SHARE_VIDEO_POPUP",
  TOGGLE_ATHLETES_COACHES_LIST_POPUP: "TOGGLE_ATHLETES_COACHES_LIST_POPUP",
  SELECT_VIDEO: "SELECT_VIDEO",
  SELECT_DESELECT_COACHES: "SELECT_DESELECT_COACHES",
  SELECT_DISELECT_ATHLETES: "SELECT_DISELECT_ATHLETES",
  SHARE_VIDEO: "SHARE_VIDEO",
};

export const columnSetActionTypes = {
  TOGGLE_CREATE_COLUMN_SET: "TOGGLE_CREATE_COLUMN_SET",
  SET_BREAKDOWN_COLUMN_SET_DATA: "SET_BREAKDOWN_COLUMN_SET_DATA",
  COLUMN_SET_STATUS_DATA: "COLUMN_SET_STATUS_DATA",
};
